export const important = "kOd";
export const hasAttachments = "lOd";
export const meeting = "mOd";
export const meetingAccepted = "nOd";
export const meetingDeclined = "oOd";
export const meetingTentative = "pOd";
export const meetingCanceled = "qOd";
export default {important,hasAttachments,meeting,meetingAccepted,meetingDeclined,meetingTentative,meetingCanceled};